import { colors, alphaVar } from "@components/ui/colors";
import { Edit } from "@mui/icons-material";
import { Box, IconButton, TextField, Tooltip, Typography } from "@mui/material";

export const ServiceNameOverrideRow = ({ originalServiceName, value, isEditing, disabled = false, onEdit, onCancel, onChange }) => {
  const serviceAlias = String(value ?? "").trim();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        py: 0.75,
        gap: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: 14,
          color: colors.gray?.[400] || "var(--fx-surface-texttertiary, #94A3B8)",
          flexShrink: 0,
        }}
      >
        Service alias
      </Typography>

      {isEditing ? (
        <Box
          sx={{
            width: "100%",
            maxWidth: 280,
            textAlign: "right",
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            value={value || ""}
            placeholder="Enter service alias"
            onChange={(event) => {
              onChange(event.target.value);
            }}
            onBlur={onCancel}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                event.preventDefault();
                onCancel();
              }

              if (event.key === "Escape") {
                event.preventDefault();
                onCancel();
              }
            }}
            inputProps={{
              maxLength: 150,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 34,
                borderRadius: 1.5,
                bgcolor: "var(--fx-surface-base, #FFFFFF)",
                fontSize: 14,
                "& fieldset": {
                  borderColor: alphaVar(colors.orange.base, 0.25),
                },
                "&:hover fieldset": {
                  borderColor: colors.orange[400],
                },
                "&.Mui-focused fieldset": {
                  borderColor: colors.orange.base,
                  borderWidth: 1.5,
                },
              },
            }}
          />

          <Typography
            sx={{
              mt: 0.5,
              fontSize: 11,
              color: colors.gray?.[400] || "var(--fx-surface-texttertiary, #94A3B8)",
            }}
          >
            Original: {originalServiceName}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 0.75,
            minWidth: 0,
          }}
        >
          <Box
            sx={{
              minWidth: 0,
              textAlign: "right",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                fontWeight: 600,
                color: colors.gray?.[800] || "var(--fx-surface-text, #0F172A)",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              {serviceAlias}
            </Typography>

            <Typography
              sx={{
                mt: 0.2,
                fontSize: 11,
                color: colors.gray?.[400] || "var(--fx-surface-texttertiary, #94A3B8)",
              }}
            >
              Original: {originalServiceName}
            </Typography>
          </Box>

          {!disabled && (
            <Tooltip title="Edit service alias">
              <IconButton
                onClick={onEdit}
                size="small"
                sx={{
                  width: 24,
                  height: 24,
                  borderRadius: 1,
                  color: colors.orange.base,
                  flexShrink: 0,
                  "&:hover": {
                    bgcolor: alphaVar(colors.orange.base, 0.08),
                  },
                }}
              >
                <Edit sx={{ fontSize: 15 }} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      )}
    </Box>
  );
};
